import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useInView } from '../hooks/useInView';

// Replace these with your actual blog posts / Medium / Dev.to links
const posts = [
  {
    date: 'Coming Soon',
    category: 'Architecture',
    title: 'Optimizing Kafka Consumer Lag in High-Throughput Pipelines',
    excerpt: 'Lessons learned from reducing consumer lag in production Kafka clusters — tuning partitions, consumer groups, and commit strategies.',
    href: '#',
    readTime: '8 min read',
  },
  {
    date: 'Coming Soon',
    category: 'Backend',
    title: 'Redis Caching Patterns for Microservices',
    excerpt: 'A practical guide to cache invalidation strategies, TTL management, and avoiding stampede effects in distributed systems.',
    href: '#',
    readTime: '6 min read',
  },
  {
    date: 'Coming Soon',
    category: 'DevOps',
    title: 'Structured Logging with New Relic in NestJS',
    excerpt: 'How to instrument your NestJS application with structured logs, custom attributes, and distributed tracing for faster incident resolution.',
    href: '#',
    readTime: '5 min read',
  },
];

export default function Blog() {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="blog" ref={ref} style={{ padding: 'clamp(80px, 10vw, 140px) clamp(24px, 8vw, 120px)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(24px)', transition: 'all 0.6s ease', marginBottom: 60 }}>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--accent-warm)', marginBottom: 20 }}>
            05 — Blog
          </p>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 20 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 4vw, 52px)', lineHeight: 1.1, letterSpacing: '-0.02em' }}>
              Thoughts & writing.
            </h2>
            <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)', letterSpacing: '0.06em' }}>
              Articles coming soon — update href links above
            </p>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {posts.map((post, i) => (
            <a key={i} href={post.href}
              style={{
                display: 'grid',
                gridTemplateColumns: 'clamp(100px, 14%, 160px) 1fr auto',
                gap: 'clamp(20px, 3vw, 48px)',
                padding: '36px 0',
                borderBottom: '1px solid var(--border)',
                alignItems: 'center',
                opacity: inView ? 1 : 0,
                transform: inView ? 'none' : 'translateY(16px)',
                transition: `all 0.6s ease ${i * 0.1 + 0.2}s`,
                textDecoration: 'none',
                cursor: 'pointer',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--white)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
            >
              <div>
                <span style={{
                  fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase',
                  color: 'white', background: 'var(--accent-warm)', padding: '3px 8px', borderRadius: 2,
                  display: 'inline-block', marginBottom: 8,
                }}>{post.category}</span>
                <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)' }}>{post.date}</p>
              </div>
              <div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(18px, 1.8vw, 24px)', letterSpacing: '-0.01em', color: 'var(--ink)', marginBottom: 10 }}>
                  {post.title}
                </h3>
                <p style={{ color: 'var(--ink-3)', fontSize: 14, fontWeight: 300, lineHeight: 1.6 }}>{post.excerpt}</p>
                <p style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)', marginTop: 10 }}>{post.readTime}</p>
              </div>
              <ArrowRight size={18} strokeWidth={1.5} style={{ color: 'var(--ink-4)', flexShrink: 0 }} />
            </a>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 600px) {
          #blog > div > div:last-child > a {
            grid-template-columns: 1fr !important;
          }
          #blog > div > div:last-child > a > svg {
            display: none;
          }
        }
      `}</style>
    </section>
  );
}
